<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Get Paid More and Promoted Faster</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="chapter" id="d14e48">
<p class="center" id="d7e343"><span>BOOKS BY BRIAN TRACY</span> </p>
<p class="center" id="d7e393"><span><i>Advanced Selling Strategies </i><br/><i>Eat That Frog!</i><br/><i>Effective Leadership </i><br/><i>The Gift of Self-Confidence </i><br/><i>The Great Big Book of Wisdom </i><br/><i>Little Silver Book of Prosperity </i><br/><i>Mastering Your Time </i><br/><i>Maximum Achievement </i><br/><i>The 100 Absolutely Unbreakable Laws </i><br/><i>of Business Success </i><br/><i>The Peak Performance Woman </i><br/><i>Personal Achievement </i><br/><i>Success Is a Journey </i><br/><i>Successful Selling </i><br/><i>A Treasury of Personal Achievement </i><br/><i>The 21 Success Secrets of Self-Made Millionaires </i><br/><i>Universal Laws of Success </i><br/><br/></span></p>
<p class="center" id="d7e973"><span>COAUTHORED BY BRIAN TRACY </span></p>
<p class="center" id="d7e1023"><span><i>Speaking Secrets of the Masters </i><br/><i>Insights into Excellence </i><br/><i>Traits of Champions </i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter.vue?16adc5f3